import React, { useState, useEffect } from "react";
import "./WhyUs.css";

 const Slider = () => {
//     const [index, setIndex] = useState(0);
//     const totalSlides = 5;

//     useEffect(() => {
//         const interval = setInterval(() => {
//             setIndex((prevIndex) => (prevIndex + 2) % totalSlides);
//         }, 3000);
//         return () => clearInterval(interval);
//     }, []);

//     const slide = (direction) => {
//         setIndex((prevIndex) => {
//             let newIndex = prevIndex + direction;
//             if (newIndex < 0) return totalSlides - 0;
//             if (newIndex >= totalSlides) return 0;
//             return newIndex;
//         });
//     };

    return (
        <section className="why-us">
            <h2 className='section-heading'>
            -Why SureSend is the Trusted Partner for Global Businesses
            </h2>
            <p className='section-subheading'>SureSend empowers you to unlock growth opportunities <br></br> and scale your business across borders, 
                <br></br> providing a reliable and secure payment solution.</p>
                    <div className="why-us-content" id=''>
                        {/* <div className="slider" style={{ transform: `translateX(-${index * 100}px)` }}> */}
                        <div className='slide'>
                            <h4>Frictionless Cross-Border Payments</h4>
                            <p>SureSend takes the hassle out of international transactions, 
                                ensuring that every payment is smooth, fast, and secure.</p>
                        </div>
                        <div className='slide'>
                            <h4>Built for African Businesses</h4>
                            <p>We understand the unique needs of businesses operating in Africa. 
                                That’s why our platform is designed to help you navigate the 
                                complexities of cross-border payments and unlock growth in local markets.
                            </p>
                        </div>
                        <div className='slide'>
                            <h4>Global Reach with Local Support</h4>
                            <p>From Africa to the rest of the world, SureSend bridges the gap between continents, 
                                offering tailored solutions to meet the needs of African businesses looking to grow globally.
                            </p>
                        </div>
                        <div className='slide'>
                            <h4>Security You Can Trust</h4>
                            <p>Trust is the foundation of our service. We use advanced encryption, 
                                fraud detection, and secure transaction methods to ensure that your 
                                funds are safe and your business is protected.
                            </p>
                        </div>
                        <div className='slide'>
                            <h4>Unlock Market Potential</h4>
                            <p>Whether you’re a small enterprise or a larger organization, 
                                SureSend helps you access new markets, 
                                connect with international clients, and grow your business globally.
                            </p>
                        </div>
                    </div>

                    <div className="mobileslider">
                        <div className='slide'>
                            <h4>Frictionless Cross-Border Payments</h4>
                            <p>SureSend takes the hassle out of international transactions, 
                                ensuring that every payment is smooth, fast, and secure.</p>
                        </div>
                        <div className='slide'>
                            <h4>Built for African Businesses</h4>
                            <p>We understand the unique needs of businesses operating in Africa. 
                                That’s why our platform is designed to help you navigate the 
                                complexities of cross-border payments and unlock growth in local markets.
                            </p>
                        </div>
                        <div className='slide'>
                            <h4>Global Reach with Local Support</h4>
                            <p>From Africa to the rest of the world, SureSend bridges the gap between continents, 
                                offering tailored solutions to meet the needs of African businesses looking to grow globally.
                            </p>
                        </div>
                        <div className='slide'>
                            <h4>Security You Can Trust</h4>
                            <p>Trust is the foundation of our service. We use advanced encryption, 
                                fraud detection, and secure transaction methods to ensure that your 
                                funds are safe and your business is protected.
                            </p>
                        </div>
                        <div className='slide'>
                            <h4>Unlock Market Potential</h4>
                            <p>Whether you’re a small enterprise or a larger organization, 
                                SureSend helps you access new markets, 
                                connect with international clients, and grow your business globally.
                            </p>
                        </div>
                    </div>

                    
                {/* </div> */}
                {/* <div className="controls">
                    <button onClick={() => slide(-1)}>&#8592; </button>
                    <button onClick={() => slide(1)}> &#8594;</button>
                </div>
           */}
        </section>
    );
};

export default Slider;
